/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Collection Page SEO Footer (Amplifyr) */

window.themeObj = {
  data: {
    shop: 'une-piece.myshopify.com'  
  },
  init: function() {
    window.themeObj.templates.collection();
  },
  templates: {
    collection: function() {
      const footer = document.querySelector('.boost-pfs-collection-footer');

      if (footer) {
        const text = document.querySelector('.boost-pfs-collection-footer-text');
        const textHeight = text.offsetHeight;

        if (textHeight > 300) {
          footer.classList.add('is-collapsed');

          const textButton = document.querySelector('.boost-pfs-collection-footer-button');
  
          if (textButton) {
            textButton.addEventListener('click', function() {
              footer.classList.remove('is-collapsed');

              const footerLinks = document.querySelector('.Section__FooterLinks');

              if (footerLinks) {
                footerLinks.removeAttribute('style');
              }
            });
          }
        }
      }
    }
  },
  sections: {}
};

window.themeObj.init();

/* Tag Clarity ATC button tags */

  (function () {
    // Helper: safely send a Clarity tag
    function tagClarity(key, value) {
      try {
        if (window.clarity && typeof window.clarity === "function") {
          window.clarity("set", key, value);
        }
      } catch (e) {
        // ignore errors
      }
    }

    // Event delegation: listen for all clicks
    document.addEventListener("click", function (evt) {
      const btn = evt.target.closest('button[data-action="add-to-cart"], form[action*="/cart/add"] [type="submit"]');
      if (!btn) return;

      // Detect sticky add-to-cart (your snippet uses #StickyAddToCart-Submit inside #sticky-add-to-cart-bar)
      const isSticky = !!btn.closest("#sticky-add-to-cart-bar");

      // Detect main PDP ATC (inside .ProductForm__BuyButtons)
      const isMain = !!btn.closest(".ProductForm__BuyButtons");

      // Detect popup/quick add (modal, drawer, quick add wrappers)
      const isPopup = !!btn.closest(
        [
          ".QuickShop",
          ".QuickAdd",
          ".Modal",
          ".Drawer",
          '[role="dialog"]',
          ".Popup",
          ".js-quick-add"
        ].join(", ")
      );

      let cartButtonType = "main"; // default
      if (isSticky) cartButtonType = "sticky";
      else if (isPopup) cartButtonType = "popup";
      else if (isMain) cartButtonType = "main";

      // Send event to Clarity
      tagClarity("cart_button_type", cartButtonType);

      // (Optional) send product info
      try {
        const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        if (meta && meta.product) {
          tagClarity("product_id", String(meta.product.id));
          tagClarity("product_handle", meta.product.handle || "");
        }
      } catch (e) {}
    });
  })();

// ============================================
// QUICK ADD FEATURE - Mobile Popover Version
// ============================================

// QuickBuyModal class - Shows mobile popover with images and sizes
class QuickBuyModal extends HTMLElement {
  // Static cache for product data
  static productCache = new Map();
  
  constructor() {
    super();
    this.isOpen = false;
    this.productData = null;
    this.selectedVariantId = null;
    this.popoverElement = null;
    this.addButton = null;
    this.priceElement = null;
    this.selectedOptions = {};
    this.sizeOptionPositions = [];
    this.optionNameByPosition = {};
  }
  
  connectedCallback() {
    // Find and attach click handler to the button
    const buttonId = this.id;
    const button = document.querySelector(`[aria-controls="${buttonId}"]`);
    
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.show();
      });
    }
  }
  
  async show() {
    if (this.isOpen) return;
    this.isOpen = true;
    
    try {
      // Get the product handle
      const handleAttr = this.getAttribute("handle") || '';
      const productHandle = handleAttr.split('?')[0];
      
      // Check cache first
      if (QuickBuyModal.productCache.has(productHandle)) {
        this.productData = QuickBuyModal.productCache.get(productHandle);
        this.createPopover();
        return;
      }
      
      // Show loading indicator
      document.documentElement.classList.add('is-loading');
      
      // Fetch product data via Shopify AJAX API
      const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.status}`);
      }
      
      this.productData = await response.json();
      
      // Cache the product data
      QuickBuyModal.productCache.set(productHandle, this.productData);
      
      // Hide loading indicator
      document.documentElement.classList.remove('is-loading');
      
      // Create and show the popover
      this.createPopover();
      
    } catch (error) {
      console.error('Error loading product:', error);
      document.documentElement.classList.remove('is-loading');
      this.showErrorMessage('Unable to load product. Please try again.');
      this.isOpen = false;
    }
  }
  
  createPopover() {
    // Create popover wrapper
    const popover = document.createElement('div');
    popover.className = 'QuickAddPopover';
    popover.setAttribute('aria-hidden', 'true');
    popover.setAttribute('data-quick-add-id', this.id);
    popover.setAttribute('role', 'dialog');
    popover.setAttribute('aria-modal', 'true');
    popover.setAttribute('aria-label', 'Quick add product options');
    // Add body class to differentiate Quick Add overlay from other overlays
    document.body.classList.add('has-quick-add-open');
    
    // Create header
    const header = document.createElement('div');
    header.className = 'QuickAddPopover__Header';
    
    const title = document.createElement('h3');
    title.className = 'QuickAddPopover__Title Heading';
    title.textContent = 'Select size';
    
    const closeButton = document.createElement('button');
    closeButton.className = 'QuickAddPopover__Close';
    closeButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.addEventListener('click', () => this.hide());
    
    header.appendChild(title);
    header.appendChild(closeButton);
    
    // Create content area
    const content = document.createElement('div');
    content.className = 'QuickAddPopover__Content';
    
    // Add image carousel
    content.appendChild(this.createImageCarousel());
    
    // Add product info
    content.appendChild(this.createProductInfo());

    // Add size selector
    this.selectedOptions = {};
    this.sizeOptionPositions = [];
    this.optionNameByPosition = {};
    content.appendChild(this.createSizeSelector());
    
    // Create footer with Add to Cart button
    const footer = document.createElement('div');
    footer.className = 'QuickAddPopover__Footer';
    
    const addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'QuickAddPopover__AddButton';
    addButton.textContent = 'Add to Cart';
    addButton.disabled = true;
    addButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.addToCart();
    });
    
    this.addButton = addButton;

    // Add pre-order note element (hidden by default, reserves space to prevent layout shift)
    const preorderNote = document.createElement('div');
    preorderNote.className = 'QuickAddPopover__PreorderNote';
    preorderNote.setAttribute('aria-live', 'polite');
    footer.appendChild(preorderNote);

    footer.appendChild(addButton);
    
    // Assemble popover
    popover.appendChild(header);
    popover.appendChild(content);
    
    // Append footer to content on desktop, to popover on mobile
    if (window.innerWidth >= 1008) {
      content.appendChild(footer);
    } else {
      popover.appendChild(footer);
    }
    
    // Store reference to popover
    this.popoverElement = popover;
    
    // Add keyboard support
    this.attachKeyboardListeners(popover);
    
    // IMPORTANT: Append to document body, not to this element
    document.body.appendChild(popover);

    this.initializeDefaultSelection();

    // Show overlay
    const pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) {
      pageOverlay.classList.add('is-visible');
      pageOverlay.addEventListener('click', () => this.hide(), { once: true });
    }
    
    // Lock body scroll using centralized utility
    if (window.ScrollLock) {
      window.ScrollLock.lock();
    } else {
      // Fallback if utility not loaded
      document.documentElement.classList.add('no-scroll');
    }
    
    // Trigger animation after a small delay
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        popover.setAttribute('aria-hidden', 'false');
        const selectedButton = popover.querySelector('.QuickAddPopover__SizeButton.is-selected:not(:disabled)')
          || popover.querySelector('.QuickAddPopover__SizeButton:not(:disabled)');
        if (selectedButton) {
          selectedButton.focus();
        }
      });
    });
  }
  
  createImageCarousel() {
    const carousel = document.createElement('div');
    carousel.className = 'QuickAddPopover__ImageCarousel';
    
    const wrapper = document.createElement('div');
    wrapper.className = 'QuickAddPopover__ImageWrapper';
    
    // Get first 5 images
    const images = this.productData.images.slice(0, 5);
    
    images.forEach((imageUrl, index) => {
      // Wrap image in anchor tag
      const link = document.createElement('a');
      link.href = this.productData.url;
      link.className = 'QuickAddPopover__ImageLink';
      
      const img = document.createElement('img');
      img.className = 'QuickAddPopover__Image';
      
      // Add responsive images with srcset for better performance
      // Keep original size for src, add optimized versions for different pixel densities
      const baseUrl = imageUrl.split('?')[0];
      img.srcset = `
        ${baseUrl}?width=160 1x,
        ${baseUrl}?width=320 2x,
        ${baseUrl}?width=480 3x
      `;
      img.src = imageUrl; // Use original full-size image as fallback
      img.alt = `${this.productData.title} - Image ${index + 1}`;
      img.loading = 'lazy';
      
      link.appendChild(img);
      wrapper.appendChild(link);
    });
    
    carousel.appendChild(wrapper);
    return carousel;
  }
  
  createProductInfo() {
    const info = document.createElement('div');
    info.className = 'QuickAddPopover__Info';

    const productTitle = document.createElement('h3');
    productTitle.className = 'QuickAddPopover__ProductTitle';
    
    // Use metafield parent title if available, otherwise use product title
    const parentTitle = this.getAttribute('data-parent-title');
    productTitle.textContent = parentTitle || this.productData.title;
    
    const priceRow = document.createElement('div');
    priceRow.className = 'QuickAddPopover__PriceRow';
    
    const price = document.createElement('div');
    price.className = 'QuickAddPopover__Price';
    const initialVariant = this.getDefaultVariant();
    this.renderPrice(price, initialVariant);
    this.priceElement = price;
    
    const viewDetails = document.createElement('a');
    viewDetails.className = 'QuickAddPopover__ViewDetails';
    viewDetails.textContent = 'View Details';
    viewDetails.href = this.productData.url;
    
    priceRow.appendChild(price);
    priceRow.appendChild(viewDetails);
    
    info.appendChild(productTitle);
    info.appendChild(priceRow);
    
    return info;
  }
  
  createSizeSelector() {
    const selector = document.createElement('div');
    selector.className = 'QuickAddPopover__SizeSelector';

    const optionsArray = Array.isArray(this.productData && this.productData.options)
      ? this.productData.options
      : [];
    const variantsArray = Array.isArray(this.productData && this.productData.variants)
      ? this.productData.variants
      : [];

    const sizeOptions = optionsArray
      .map((option, index) => ({
        ...option,
        index,
        position: option && typeof option.position === 'number' ? option.position : index + 1
      }))
      .filter(option => option && option.name && option.name.toLowerCase().includes('size'))
      .sort((a, b) => a.position - b.position);

    if (!sizeOptions.length) {
      const label = document.createElement('span');
      label.className = 'QuickAddPopover__SizeLabel';
      label.textContent = 'Size:';
      selector.appendChild(label);
      return selector;
    }

    sizeOptions.forEach((option) => {
      const position = Number(option.position) || option.index + 1;
      if (!this.sizeOptionPositions.includes(position)) {
        this.sizeOptionPositions.push(position);
      }
      this.optionNameByPosition[position] = option.name;

      const group = document.createElement('div');
      group.className = 'QuickAddPopover__SizeGroup';

      const label = document.createElement('span');
      label.className = 'QuickAddPopover__SizeLabel';
      label.textContent = `${option.name}:`;
      const labelId = `quick-add-size-label-${this.id}-${position}`;
      label.id = labelId;

      const grid = document.createElement('div');
      grid.className = 'QuickAddPopover__SizeGrid';
      grid.setAttribute('role', 'radiogroup');
      grid.setAttribute('aria-labelledby', labelId);
      grid.dataset.optionPosition = String(position);

      const values = Array.isArray(option.values) ? option.values : [];

      values.forEach((value, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'QuickAddPopover__SizeButton';
        button.textContent = value;
        button.dataset.optionPosition = String(position);
        button.dataset.optionValue = value;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');
        button.setAttribute('tabindex', index === 0 ? '0' : '-1');

        const optionKey = `option${position}`;
        const matchingVariants = variantsArray.filter(variant => variant && variant[optionKey] === value);

        if (!matchingVariants.some(variant => variant && variant.available)) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('tabindex', '-1');
        }

        grid.appendChild(button);
      });

      grid.addEventListener('click', (event) => {
        const button = event.target.closest('.QuickAddPopover__SizeButton');
        if (button && !button.disabled) {
          this.selectOptionButton(button, { userInitiated: true });
        }
      });

      grid.addEventListener('keydown', (event) => {
        this.handleSizeGridKeyboard(event, grid);
      });

      group.appendChild(label);
      group.appendChild(grid);
      selector.appendChild(group);
    });

    return selector;
  }
  
  handleSizeGridKeyboard(event, grid) {
    const buttons = Array.from(grid.querySelectorAll('.QuickAddPopover__SizeButton:not(:disabled)'));
    const currentButton = event.target;
    const currentIndex = buttons.indexOf(currentButton);
    
    let nextIndex = currentIndex;
    
    switch(event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        nextIndex = (currentIndex + 1) % buttons.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        break;
      case 'Home':
        event.preventDefault();
        nextIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        nextIndex = buttons.length - 1;
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.selectOptionButton(currentButton, { userInitiated: true });
        return;
      default:
        return;
    }
    
    // Update tabindex and focus
    buttons.forEach((btn, idx) => {
      btn.setAttribute('tabindex', idx === nextIndex ? '0' : '-1');
    });
    buttons[nextIndex].focus();
  }
  
  selectOptionButton(button, options = {}) {
    if (!button || !this.popoverElement) {
      return;
    }

    const {
      updateVariant = true,
      userInitiated = true,
      focus = false,
      skipAvailabilityUpdate = false
    } = options;

    const grid = button.closest('.QuickAddPopover__SizeGrid');
    const optionPosition = Number(button.dataset.optionPosition);
    const optionValue = button.dataset.optionValue;

    if (!grid || !optionPosition || typeof optionValue !== 'string') {
      return;
    }

    const buttons = Array.from(grid.querySelectorAll('.QuickAddPopover__SizeButton'));
    buttons.forEach((btn) => {
      const isSelected = btn === button;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      btn.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.selectedOptions[optionPosition] = optionValue;

    if (focus) {
      button.focus();
    }

    if (updateVariant) {
      if (!skipAvailabilityUpdate) {
        this.updateOptionAvailability();
        this.ensureSelections({ userInitiated: false });
      }
      this.updateVariantSelection({ triggerButton: button, userInitiated });
    }
  }

  updateOptionAvailability() {
    if (!this.popoverElement || !this.productData || !Array.isArray(this.productData.variants)) {
      return;
    }

    const variants = this.productData.variants;
    const buttons = this.popoverElement.querySelectorAll('.QuickAddPopover__SizeButton');

    buttons.forEach((button) => {
      const position = Number(button.dataset.optionPosition);
      const value = button.dataset.optionValue;

      if (!position || typeof value !== 'string') {
        return;
      }

      const optionKey = `option${position}`;

      let variantExists = false;
      let variantAvailable = false;

      variants.forEach((variant) => {
        if (!variant || variant[optionKey] !== value) {
          return;
        }

        const matchesSelections = this.sizeOptionPositions.every((pos) => {
          if (pos === position) {
            return true;
          }

          const selectedValue = this.selectedOptions[pos];
          if (!selectedValue) {
            return true;
          }

          const compareKey = `option${pos}`;
          return variant[compareKey] === selectedValue;
        });

        if (matchesSelections) {
          variantExists = true;

          if (variant.available) {
            variantAvailable = true;
          }
        }
      });

      if (!variantExists) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.remove('is-selected');
        button.setAttribute('aria-checked', 'false');
        button.setAttribute('tabindex', '-1');

        if (this.selectedOptions[position] === value) {
          delete this.selectedOptions[position];
        }
        return;
      }

      if (!variantAvailable) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');

        if (this.selectedOptions[position] === value) {
          delete this.selectedOptions[position];
        }
        return;
      }

      if (button.disabled) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }

      const isSelected = this.selectedOptions[position] === value;
      button.setAttribute('tabindex', isSelected ? '0' : '-1');
    });
  }

  ensureSelections(options = {}) {
    if (!this.popoverElement) {
      return;
    }

    const { userInitiated = false } = options;

    this.sizeOptionPositions.forEach((position) => {
      const grid = this.popoverElement.querySelector(`.QuickAddPopover__SizeGrid[data-option-position="${position}"]`);
      if (!grid) {
        return;
      }

      const currentValue = this.selectedOptions[position];
      if (currentValue) {
        const selectedButton = Array.from(grid.querySelectorAll('.QuickAddPopover__SizeButton')).find((btn) =>
          btn.dataset.optionValue === currentValue && !btn.disabled
        );

        if (selectedButton) {
          return;
        }

        delete this.selectedOptions[position];
      }

      const firstAvailable = grid.querySelector('.QuickAddPopover__SizeButton:not(:disabled)');
      if (firstAvailable) {
        this.selectOptionButton(firstAvailable, {
          updateVariant: false,
          userInitiated,
          skipAvailabilityUpdate: true
        });
      }
    });
  }

  updateVariantSelection(options = {}) {
    if (!this.productData || !Array.isArray(this.productData.variants)) {
      return;
    }

    const { triggerButton = null, userInitiated = true } = options;

    if (!this.sizeOptionPositions.length) {
      const defaultVariant = this.getDefaultVariant();
      if (defaultVariant) {
        this.applyVariantSelection(defaultVariant, { triggerButton, userInitiated });
      }
      return;
    }

    const allSelected = this.sizeOptionPositions.every((position) => {
      const value = this.selectedOptions[position];
      return typeof value === 'string' && value.length > 0;
    });

    if (!allSelected) {
      this.selectedVariantId = null;
      if (this.addButton) {
        const hasEnabledButtons = this.popoverElement
          ? this.popoverElement.querySelector('.QuickAddPopover__SizeButton:not(:disabled)')
          : null;
        this.addButton.disabled = true;
        this.addButton.textContent = hasEnabledButtons ? 'Select options' : 'Sold Out';
      }
      this.updatePreorderInfo(null);
      return;
    }

    const matchingVariant = this.productData.variants.find((variant) =>
      this.sizeOptionPositions.every((position) => {
        const optionKey = `option${position}`;
        return variant[optionKey] === this.selectedOptions[position];
      })
    );

    if (matchingVariant) {
      this.applyVariantSelection(matchingVariant, { triggerButton, userInitiated });
    } else {
      this.selectedVariantId = null;
      if (this.addButton) {
        this.addButton.disabled = true;
        this.addButton.textContent = 'Unavailable';
      }
      this.updatePreorderInfo(null);
    }
  }

  applyVariantSelection(variant, options = {}) {
    if (!variant) {
      return;
    }

    const { triggerButton = null, userInitiated = true } = options;

    this.selectedVariantId = variant.id;
    this.updatePrice(variant.id);

    if (this.addButton) {
      if (variant.available) {
        this.addButton.disabled = false;
        this.addButton.textContent = 'Add to Cart';
      } else {
        this.addButton.disabled = true;
        this.addButton.textContent = 'Sold Out';
      }
    }

    this.updatePreorderInfo(variant);

    if (userInitiated && triggerButton) {
      const optionPosition = Number(triggerButton.dataset.optionPosition);
      const optionName = this.getOptionNameByPosition(optionPosition);

      const eventData = {
        product_id: this.productData.id,
        variant_id: variant.id,
        size: triggerButton.textContent
      };

      if (optionName) {
        eventData.option_name = optionName;
      }

      this.trackEvent('quick_add_size_selected', eventData);
    }
  }

  initializeDefaultSelection() {
    if (!this.popoverElement) {
      return;
    }

    const defaultVariant = this.getDefaultVariant();

    if (!defaultVariant) {
      if (this.addButton) {
        this.addButton.disabled = true;
        this.addButton.textContent = 'Sold Out';
      }
      return;
    }

    if (!this.sizeOptionPositions.length) {
      this.applyVariantSelection(defaultVariant, { userInitiated: false });
      return;
    }

    const buttons = Array.from(this.popoverElement.querySelectorAll('.QuickAddPopover__SizeButton'));

    this.sizeOptionPositions.forEach((position) => {
      const optionKey = `option${position}`;
      const desiredValue = defaultVariant[optionKey];
      if (!desiredValue) {
        return;
      }

      const match = buttons.find((btn) =>
        Number(btn.dataset.optionPosition) === position && btn.dataset.optionValue === desiredValue
      );

      if (match) {
        this.selectOptionButton(match, { updateVariant: false, userInitiated: false });
      }
    });

    this.updateOptionAvailability();
    this.ensureSelections({ userInitiated: false });
    this.updateVariantSelection({ userInitiated: false });
  }

  getOptionNameByPosition(position) {
    return this.optionNameByPosition[position] || null;
  }

  updatePrice(variantId) {
    if (!this.priceElement || !this.productData) return;

    const variant = this.getVariantById(variantId);
    if (!variant) return;

    this.renderPrice(this.priceElement, variant);
  }

  renderPrice(container, variant) {
    if (!container) {
      return;
    }

    const productPrice = variant ? variant.price : (this.productData && this.productData.price);
    const compareAtPrice = variant && variant.compare_at_price;
    const priceValue = typeof productPrice === 'number' ? productPrice : 0;
    const compareAtValue = typeof compareAtPrice === 'number' ? compareAtPrice : null;
    const isOnSale = compareAtValue !== null && compareAtValue > priceValue;

    container.innerHTML = '';

    if (isOnSale) {
      const comparePriceElement = document.createElement('span');
      comparePriceElement.className = 'Price Price--compareAt Text--subdued';
      comparePriceElement.setAttribute('data-money-convertible', '');
      comparePriceElement.textContent = this.formatMoney(compareAtValue);
      container.appendChild(comparePriceElement);
    }

    const salePriceElement = document.createElement('span');
    salePriceElement.className = isOnSale
      ? 'Price Price--highlight Text--subdued'
      : 'Price Text--subdued';
    salePriceElement.setAttribute('data-money-convertible', '');
    salePriceElement.textContent = this.formatMoney(priceValue);
    container.appendChild(salePriceElement);
  }
  
  updatePreorderInfo(variant) {
    if (!this.addButton || !this.productData || !this.popoverElement) {
      return;
    }

    const preorderNote = this.popoverElement.querySelector('.QuickAddPopover__PreorderNote');

    if (!preorderNote) {
      return;
    }

    if (!variant || !variant.available) {
      preorderNote.textContent = '';
      preorderNote.classList.remove('is-visible');
      return;
    }

    const inventoryLevel = typeof variant.inventory_quantity === 'number'
      ? variant.inventory_quantity
      : null;

    if (inventoryLevel === null || inventoryLevel > 0) {
      preorderNote.textContent = '';
      preorderNote.classList.remove('is-visible');
      return;
    }

    this.addButton.textContent = 'Pre-order';

    let noteText = 'Pre-order available';

    const allocations = Array.isArray(variant.selling_plan_allocations)
      ? variant.selling_plan_allocations
      : [];
    const spGroups = Array.isArray(this.productData.selling_plan_groups)
      ? this.productData.selling_plan_groups
      : [];

    if (allocations.length && spGroups.length) {
      const alloc = allocations[0];
      const allPlans = spGroups.reduce((plans, group) => {
        const sellingPlans = Array.isArray(group.selling_plans) ? group.selling_plans : [];
        return plans.concat(sellingPlans);
      }, []);

      const matchedPlan = allPlans.find((plan) => String(plan.id) === String(alloc.selling_plan_id));

      if (matchedPlan && matchedPlan.name) {
        noteText = matchedPlan.name;
      }
    }

    preorderNote.textContent = noteText;
    preorderNote.classList.add('is-visible');
  }

  getVariantById(variantId) {
    if (!this.productData || !Array.isArray(this.productData.variants)) return null;
    return this.productData.variants.find(variant => String(variant.id) === String(variantId)) || null;
  }

  getDefaultVariant() {
    if (!this.productData || !Array.isArray(this.productData.variants)) return null;
    return this.productData.variants.find(variant => variant.available) || this.productData.variants[0] || null;
  }
  
  async addToCart() {
    if (!this.selectedVariantId || !this.addButton) {
      return;
    }
    
    try {
      // Show loading state
      this.addButton.disabled = true;
      this.addButton.textContent = 'Adding...';
      
      const formData = new FormData();
      formData.append('id', this.selectedVariantId);
      formData.append('quantity', 1);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`Failed to add to cart: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Track add to cart in analytics
      this.trackEvent('quick_add_to_cart', {
        product_id: this.productData.id,
        variant_id: this.selectedVariantId,
        product_title: this.productData.title,
        price: data.price
      });
      
      // Close popover but keep overlay visible for smooth transition to cart drawer
      this.hide(true);
      
      // Trigger cart refresh - theme will handle opening drawer
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      
      // Dispatch product:added event - theme listens to this and opens drawer automatically
      document.dispatchEvent(new CustomEvent('product:added', {
        detail: {
          variant: data,
          quantity: 1
        }
      }));
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showErrorMessage('Unable to add item to cart. Please try again.');
      
      // Track error in analytics
      this.trackEvent('quick_add_error', {
        error: error.message,
        product_id: this.productData.id
      });
      
      // Reset button
      if (this.addButton) {
        this.addButton.disabled = false;
        this.addButton.textContent = 'Add to Cart';
      }
    }
  }
  
  attachKeyboardListeners(popover) {
    popover.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hide();
      }
      
      // Trap focus within popover
      if (e.key === 'Tab') {
        this.trapFocus(e, popover);
      }
    });
  }
  
  trapFocus(event, popover) {
    const focusableElements = popover.querySelectorAll(
      'button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    
    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  }
  
  hide(keepOverlay = false) {
    if (!this.isOpen) return;
    
    if (this.popoverElement) {
      this.popoverElement.setAttribute('aria-hidden', 'true');
      
      setTimeout(() => {
        // Remove from body
        if (this.popoverElement && this.popoverElement.parentNode) {
          this.popoverElement.parentNode.removeChild(this.popoverElement);
        }
        this.popoverElement = null;
        this.addButton = null;
        this.selectedVariantId = null;
        this.priceElement = null;
        this.selectedOptions = {};
        this.sizeOptionPositions = [];
        this.optionNameByPosition = {};
        this.isOpen = false;
      }, 400);
    } else {
      this.isOpen = false;
    }
    
    // Hide overlay (unless we're keeping it for transition to cart drawer)
    if (!keepOverlay) {
      const pageOverlay = document.querySelector('.PageOverlay');
      if (pageOverlay) {
        pageOverlay.classList.remove('is-visible');
      }
    }
    
    // Unlock body scroll using centralized utility
    if (window.ScrollLock) {
      window.ScrollLock.unlock();
    } else {
      // Fallback if utility not loaded
      document.documentElement.classList.remove('no-scroll');
    }

    // Remove body class when Quick Add closes regardless of ScrollLock availability
    document.body.classList.remove('has-quick-add-open');
  }
  
  formatMoney(cents) {
      // Use Shopify's money format if available
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, '${{amount}}');
      }
      
      // Fallback to simple formatting
      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }
  
  showErrorMessage(message) {
    // Create a simple toast notification
    const toast = document.createElement('div');
    toast.className = 'QuickAddPopover__ErrorToast';
    toast.textContent = message;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    
    document.body.appendChild(toast);
    
    // Trigger animation
    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });
    
    // Remove after 3 seconds
    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 3000);
  }
  
  trackEvent(eventName, data = {}) {
    // Track with Google Analytics / GA4
    if (window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...data
      });
    }
    
    // Track with other analytics platforms if needed
    if (window.gtag) {
      window.gtag('event', eventName, data);
    }
  }
}

// Register the custom element
if (!window.customElements.get("quick-buy-modal")) {
  window.customElements.define("quick-buy-modal", QuickBuyModal);
}

// ===== PRODUCT-ITEM QUICK ADD FORM HANDLER =====
document.addEventListener('DOMContentLoaded', function() {
  // iOS Safari still flickers the header until ScrollLock has been toggled once.
  // Mimic the Quick Add / Cart drawer lifecycle so the page starts in the same
  // stable compositing state without requiring the customer to open an overlay.
  const isIOSDevice = (() => {
    const platform = window.navigator.platform || '';
    const userAgent = window.navigator.userAgent || '';

    return /iP(ad|hone|od)/.test(platform) || /iP(ad|hone|od)/.test(userAgent) ||
      (platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  })();

  if (isIOSDevice) {
    const html = document.documentElement;
    const body = document.body;

    const alreadyLocked = (
      (window.ScrollLock && typeof window.ScrollLock.isLocked === 'function' && window.ScrollLock.isLocked()) ||
      html.classList.contains('no-scroll')
    );

    if (!alreadyLocked) {
      const toggleWithScrollLock = () => {
        if (
          window.ScrollLock &&
          typeof window.ScrollLock.lock === 'function' &&
          typeof window.ScrollLock.unlock === 'function'
        ) {
          window.ScrollLock.lock();

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              window.ScrollLock.unlock();
            });
          });

          return true;
        }

        return false;
      };

      const toggleManually = () => {
        const originalPosition = body.style.position;
        const originalTop = body.style.top;
        const originalWidth = body.style.width;
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;

        html.classList.add('no-scroll');
        body.style.position = 'fixed';
        body.style.top = `-${scrollPosition}px`;
        body.style.width = '100%';

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            html.classList.remove('no-scroll');
            body.style.position = originalPosition;
            body.style.top = originalTop;
            body.style.width = originalWidth;
            window.scrollTo(0, scrollPosition);
          });
        });
      };

      if (!toggleWithScrollLock()) {
        toggleManually();
      }
    }
  }

  // Handle single-variant quick add forms
  const quickAddForms = document.querySelectorAll('.ProductItem__QuickAddForm');
  
  quickAddForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const button = form.querySelector('button[type="submit"]');
      const originalHTML = button.innerHTML;
      
      // Show loading state
      button.disabled = true;
      button.style.opacity = '0.6';
      
      const formData = new FormData(form);
      const variantId = formData.get('id');
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        // Track single variant add to cart
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'quick_add_single_variant',
            variant_id: variantId,
            product_id: data.product_id
          });
        }
        
        // Trigger cart update
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        // Dispatch product:added event
        document.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            variant: data,
            quantity: 1
          }
        }));
        
        // Try to open cart drawer
        setTimeout(() => {
          const cartDrawer = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
          if (cartDrawer) {
            cartDrawer.click();
          }
        }, 100);
        
        // Reset button
        button.disabled = false;
        button.style.opacity = '1';
        button.innerHTML = originalHTML;
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error toast
        const toast = document.createElement('div');
        toast.className = 'QuickAddPopover__ErrorToast';
        toast.textContent = 'Unable to add item to cart. Please try again.';
        toast.setAttribute('role', 'alert');
        document.body.appendChild(toast);
        
        requestAnimationFrame(() => {
          toast.classList.add('is-visible');
        });
        
        setTimeout(() => {
          toast.classList.remove('is-visible');
          setTimeout(() => {
            if (toast.parentNode) {
              toast.parentNode.removeChild(toast);
            }
          }, 300);
        }, 3000);
        
        // Reset button
        button.disabled = false;
        button.style.opacity = '1';
        button.innerHTML = originalHTML;
      });
    });
  });
});
// ===== END PRODUCT-ITEM QUICK ADD FORM HANDLER =====

// ============================================
// END QUICK ADD FEATURE
// ============================================